import React from "react";
import { NavLink } from "react-router-dom";
import { Home, LineChart, Activity, User, ShieldCheck } from "lucide-react";
import { useAdminPending } from "@/context/AdminPendingContext";

const NAV_ITEMS = [
  { to: "/",            label: "Home",        subtitle: "Announcements",      icon: Home,       testId: "nav-home" },
  { to: "/education",   label: "Education",   subtitle: "Learning Materials", icon: LineChart,  testId: "nav-education" },
  { to: "/performance", label: "Performance", subtitle: "Signals & Stats",    icon: Activity,   testId: "nav-performance" },
  { to: "/profile",     label: "Profile",     subtitle: "Account",            icon: User,       testId: "nav-profile" },
];

function NavItem({ item }) {
  return (
    <NavLink
      to={item.to}
      end={item.to === "/"}
      data-testid={item.testId}
      className={({ isActive }) =>
        `group flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${
          isActive ? "bg-[#00b4ff] text-white shadow-[0_10px_24px_-12px_#00b4ff]" : "text-slate-700 hover:bg-slate-100"
        }`
      }
    >
      {({ isActive }) => (
        <>
          <item.icon size={18} className={isActive ? "text-white" : "text-slate-500"} />
          <div className="leading-tight">
            <div className="font-display font-semibold text-sm">{item.label}</div>
            <div className={`text-[10px] tracking-widest uppercase font-mono-plex ${isActive ? "text-white/80" : "text-slate-400"}`}>
              {item.subtitle}
            </div>
          </div>
        </>
      )}
    </NavLink>
  );
}

export default function Navigation({ isAdmin }) {
  const { counts } = useAdminPending();
  const pending = counts.total || 0;
  return (
    <nav className="px-3 pb-4 space-y-1">
      {NAV_ITEMS.map((item) => (
        <NavItem key={item.to} item={item} />
      ))}

      {isAdmin && (
        <NavLink
          to="/admin"
          data-testid="nav-admin"
          className={({ isActive }) =>
            `relative flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${
              isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
            }`
          }
        >
          <div className="relative">
            <ShieldCheck size={18} />
            {pending > 0 && (
              <span
                data-testid="nav-admin-badge"
                className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] px-1 rounded-full bg-rose-500 text-white text-[9px] font-mono-plex font-bold grid place-items-center border-2 border-white"
                aria-label={`${pending} pending unlock requests`}
              >
                {pending > 9 ? "9+" : pending}
              </span>
            )}
          </div>
          <div className="leading-tight">
            <div className="font-display font-semibold text-sm">Admin Panel</div>
            <div className="text-[10px] tracking-widest uppercase font-mono-plex opacity-70">Command Center</div>
          </div>
        </NavLink>
      )}
    </nav>
  );
}
